import React from 'react';

import { Box, FormHelperText, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FieldArray } from 'formik';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import TextFieldFormik from '../../../../../common/text_field';
import DatePickerFormik from '../../../../../common/date_picker';

const ProductsList = ({ formik, productsListIndex, withExpirationDate, disabled, disabledPrice }) => {
    const handleArrowKeys = (e, productsListIndex, index, fieldName, formik) => {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            const nextInput = document.querySelector(
                `input[name="productsList.${ productsListIndex }.${ index + 1 }.${ fieldName }"]`
            );
            nextInput?.focus();
        }
        if (e.key === "ArrowUp") {
            e.preventDefault();
            const prevInput = document.querySelector(
                `input[name="productsList.${ productsListIndex }.${ index - 1 }.${ fieldName }"]`
            );
            prevInput?.focus();
        }
    };

    const onFocusHandler = (e) => {
        e.target.select();
    };

    return (
        <FieldArray
            name={ `productsList.${ productsListIndex }` }
            render={ (arrayHelpers) => (
                <Box sx={ { display: 'flex', flexDirection: 'column', gap: 1 } }>
                    <TableContainer component={ Paper } variant="outlined" sx={ { backgroundColor: 'background.paper' } }>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600, whiteSpace: 'nowrap' } } }>
                                    <TableCell style={ { width: '5%' } }>Lp.</TableCell>
                                    <TableCell>Nazwa</TableCell>
                                    <TableCell align="center" style={ { width: '12%' } }>Liczba szt.</TableCell>
                                    {
                                        withExpirationDate &&
                                        <TableCell align="center" style={ { width: '15%' } }>Data przydatności</TableCell>
                                    }
                                    <TableCell align="center" style={ { width: '15%' } }>Cena zakupu [netto]</TableCell>
                                    {
                                        !disabled &&
                                        <TableCell align="center" style={ { width: '5%' } }>Usuń</TableCell>
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    formik?.values?.productsList[productsListIndex]?.map((product, index) => {
                                        return (
                                            <TableRow
                                                key={ `${ productsListIndex }-${ index }-${ product?.productId || product?.name }` }
                                                hover
                                            >
                                                <TableCell>{ index + 1 }</TableCell>
                                                <TableCell>
                                                    <TextFieldFormik
                                                        name={ `productsList.${ productsListIndex }.${ index }.name` }
                                                        size="small"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextFieldFormik
                                                        name={ `productsList.${ productsListIndex }.${ index }.quantity` }
                                                        size="small"
                                                        type="number"
                                                        inputProps={ { min: '1', step: '1' } }
                                                        onKeyDown={ (e) => handleArrowKeys(e, productsListIndex, index, 'quantity', formik) }
                                                        onFocus={ onFocusHandler }
                                                        disabled={ disabled }
                                                    />
                                                </TableCell>
                                                {
                                                    withExpirationDate &&
                                                    <TableCell align="center">
                                                        <DatePickerFormik
                                                            name={ `productsList.${ productsListIndex }.${ index }.expirationDate` }
                                                            size="small"
                                                            InputLabelProps={ { shrink: true } }
                                                            disabled={ disabled }
                                                        />
                                                    </TableCell>
                                                }
                                                <TableCell align="center">
                                                    <TextFieldFormik
                                                        name={ `productsList.${ productsListIndex }.${ index }.price` }
                                                        size="small"
                                                        type="number"
                                                        inputProps={ { min: '0.01', max: '100.00', step: '0.01' } }
                                                        onKeyDown={ (e) => handleArrowKeys(e, productsListIndex, index, 'price', formik) }
                                                        onFocus={ onFocusHandler }
                                                        disabled={ disabledPrice }
                                                    />
                                                </TableCell>
                                                {
                                                    !disabled &&
                                                    <TableCell align="center">
                                                        <IconButton
                                                            onClick={ () => arrayHelpers.remove(index) }
                                                            title="Usuń z listy">
                                                            <RemoveCircleIcon/>
                                                        </IconButton>
                                                    </TableCell>
                                                }
                                            </TableRow>
                                        );
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>

                    { typeof formik?.errors?.productsList?.[productsListIndex] === 'string' && (
                        <FormHelperText error>
                            { formik.errors.productsList[productsListIndex] }
                        </FormHelperText>
                    ) }
                </Box>
            ) }
        />
    );
};

export default ProductsList;